module.exports = __webpack_public_path__ + "img/student-testimonial002.0d228b48.png";